export const PROFILE_CARDS_TRANSITION_TIMEOUT = 900;
